/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.payment

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Payment(
    val id: String,
    @SerialName("session_id")
    val sessionId: String,
    @SerialName("patient_id")
    val patientId: String,
    val amount: Long,
    val method: PaymentMethod,
    val notes: String? = null,
    @SerialName("received_at")
    val receivedAt: String,
    @SerialName("created_at")
    val createdAt: String,
)
